var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fill=false"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.744 2.88098L21.024 11.137C21.168 11.281 21.344 11.353 21.552 11.353C21.76 11.353 21.936 11.281 22.08 11.137C22.224 10.993 22.296 10.817 22.296 10.609C22.296 10.401 22.224 10.225 22.08 10.081L12 0.000976562L1.91998 10.081C1.77598 10.225 1.70398 10.401 1.70398 10.609C1.70398 10.817 1.77598 10.993 1.91998 11.137C2.06398 11.281 2.23998 11.353 2.44798 11.353C2.65598 11.353 2.83198 11.281 2.97598 11.137L11.256 2.88098V23.257C11.256 23.465 11.328 23.641 11.472 23.785C11.616 23.929 11.792 24.001 12 24.001C12.208 24.001 12.384 23.929 12.528 23.785C12.672 23.641 12.744 23.465 12.744 23.257V2.88098Z",
    fill: "#474747"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.a1f935ab938698d93053b4712ded6b95.svg";
export { ForwardRef as ReactComponent };